import React, { useState } from 'react';
import cn from './../../lib/bem';
import contanto_asesor from './../../assets/svg/contacto_asesor.svg';
import ico_audifonos from './../../assets/svg/ico_audifonos.svg';

import './buttonFlotante_component.scss';
import { useSelector } from 'react-redux';

const ButtonFlotanteComponent = ({ mostrarModal }) => {
  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);
  const classes = cn('buttonFlotanteComponent');
  const [activeContainer, setActiveContainer] = useState(false);

  const openContact = () => {
    setActiveContainer(!activeContainer);
  };

  return (
    <div className={classes()}>
      <div className={classes('contact-texts-new')}>
        {/* <img src={contanto_asesor} alt={'contacto'} onClick={props.mostrarModal} />  */}
        <img
          src={contanto_asesor}
          alt={'contacto'}
          onClick={() => {
            if (simuladorFVG.nombreProspecto) {
              return mostrarModal(true);
            } else {
              return window.open(
                'https://solicitud.pacifico.com.pe/seguro-renta-fondo-vida-garantizado?utm_source=simuladorfondovidagarantizado&utm_medium=simuladorfondovidagarantizado&from=PAC_RENTAS-FONDO-VIDA-GARANTIZADO-FVG_SIMULADOR-FONDOVIDAGARANTIZADO',
                '_blank'
              );
            }
          }}
        />
      </div>
      <button
        className={classes('contact-toggle-new')}
        id="openContact"
        onClick={() => openContact()}
      >
        <img
          src={ico_audifonos}
          alt={'ico_audifonos'}
          className={classes('classImage')}
        />
      </button>
    </div>
  );
};

export default ButtonFlotanteComponent;
